import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSeason$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSeason extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '95ea963a3972bb96cdfbb0be40f6ea04b8ea7564', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '565252d004464ea2b7c02fd802fac0766c36ee7d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8d8db140e5b85dc610c5768816497b7b14d9fb23', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.51 5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5zm.99 1.5h9v9h-9zm12.49 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM18.48 8a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM6 13.32V8.68a.2.2 0 0 1 .31-.17l4.14 2.32a.21.21 0 0 1 0 .34L6.3 13.49a.2.2 0 0 1-.3-.17", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-season", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-season"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-season":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSeason$1);
            }
            break;
    } });
}

const CosmosIconSeason = CosmosIconSeason$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSeason, defineCustomElement };
